import BrowseView from "./BrowseView";

export default BrowseView;
